module.exports = __webpack_public_path__ + "img/28.603cc2a7.png";